const experience_lifetime_list = [
  { value: 'none_0', name: 'None (0)' },
  { value: '1_5', name: '1-5' },
  { value: '6_10', name: '6-10' },
  { value: '11plus', name: '11+' },
  { value: '25plus', name: '25+' },
  { value: '50plus', name: '50+' },
  { value: '100plus', name: '100+' },
  { value: '200plus', name: '200+' },
  { value: '500plus', name: '500+' },
  { value: '1000plus', name: '1000+' },
  { value: '2000plus', name: '2000+' },
];

export default experience_lifetime_list;



// WEBPACK FOOTER //
// ./src/constants/experience_lifetime_list.js